import React from "react";

import Thumb from "../components/Thumb";
import Pagination from "../components/Pagination";
//import Icon from "../components/Icon";
import Title from "../components/Title";
import Dropdown from "../components/Dropdown";
import {Button} from "../components/Button";
import Toggle from "../components/Toggle";
import Upload from "../components/upload/Uploads";
import SubControls from "../components/SubControls";
import {bindActionCreators} from "redux";
import {fetchMedias, resetMedias} from "../../creators/medias";
import connect from "react-redux/es/connect/connect";
import {fetchVideoCategories} from "../../creators/videoCategories";
import {LoadingBar, PageLoader} from "../components/Loader";
import Aqp from "../../libs/mk-react-aqp";
import Modal from "../components/Modal";
import {Can} from "../../ability-context";
import createLink from "../../libs/createLink";
import Helmet from "react-helmet";
import {config} from "../../config";
import {canonical} from "../../libs/helper";
import history from "../../libs/history";
import MobileLiveTool from "../components/marketing/MobileLiveTool";
import {Link} from "react-router-dom";
import Advertising from "../components/Advertising/Advertising";
import TagModerationQualificationWarning
    from "../components/TagModerationQualificationWarning/TagModerationQualificationWarning";

let mapping = {
    'currentYear': 'annee',
    'currentMonth': 'mois',
    'tags': 'categorie',
    'isCreator': 'createur',
    //'videoSelectionVoissa': 'selection-voissa'
};
/*
const iconCategories = {
    "caresses-feminines" : "feminine-caress",
    "charnel-bestial" : "bestial",
    "de-lui-a-elle" : "him-to-her",
    "masques" : "mask",
    "tout-en-douceur" : "tout-en-douceur",
    "preliminaires-elle-a-lui" : "her-to-him",
    "entre-elles" : "woman-couple",
    "sans-titre" : "unclassifiable",
    "caresses-masculines" : "masculin-caress",
    "a-la-maison" : "home-sex",
    "trio-plan-a-trois" : "threesome",
    "a-plusieurs" : "a-plusieurs",
    "en-plein-air" : "outdoor-sex",
    "jeux-sexuels" : "handcuffs",
    "montages" : "video-editing",
    "en-public" : "public-sex",
    "entre-eux" : "man-couple",
    "transexuels" : "trans-video",
    "de-elle-a-lui" : "tout-en-douceur"
};*/

class Video extends React.Component {
    constructor(props) {
        super(props);
        this.sort = [{id : 1, title : 'Plus populaires'}/*, {id : 4, title : 'de commentaires'}*/, {id : 0 , title : 'Plus récentes'}];
        this.filter = {
            limit: 30,
            sort: 1,
            page: 1,
            kind: "video",
            "file.state" : 1,
            isFriends: false,
            isVoissaCreator: false,
            isCreator: false,
            period: 0,
            currentYear: "",
            currentMonth: "",
            //videoSelectionVoissa: false,
            tags: "",
            gender: []
        };
        this.aqp = new Aqp(mapping, {
            blacklist: ['limit', 'page', 'kind'],
            currentLink: createLink('videos'),
            filterDefault: this.filter
        });
        let gender = this.aqp.query.gender || [];
        gender = Array.isArray(gender) ? gender : [gender];
        let sort = this.aqp.query.sort ? parseInt(this.aqp.query.sort) :  1;
        this.state = {
            filter: {...this.filter, ...this.aqp.query, gender, sort, page: this.props.match.params.page || 1},
            currentVideoSelection: 0,
            leftArrowVisible: false,
            rightArrowVisible: true
        };
        this.handleChangePage = this.handleChangePage.bind(this);
        //this.handleChangeVideoSelection = this.handleChangeVideoSelection.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.handlePeriod = this.handlePeriod.bind(this);
        this.handleVideoCategorie = this.handleVideoCategorie.bind(this);

        this.facetteTagScroll = this.facetteTagScroll.bind(this);
        this.facetteTagShowHideArrows = this.facetteTagShowHideArrows.bind(this);

        this.getMedias(this.state.filter);
        /*this.props.fetchVideoCategories("video",{
            // "optionFilter": "category",
            sort: "infos.video.weight",
            isActive : true
        });*/

        this.props.fetchVideoCategories({
            sort : "-count",
            limit : 20
        });
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {   
        if(prevProps.location.search !== this.props.location.search && this.props.location.search.length === 0 && prevProps.location.search !== "?"){
            this.getMedias(this.filter);
            this.setState({filter: this.filter});
        }
    }

    componentWillUnmount() {
        this.props.resetMedias();
    }

    getMedias(filter) {
        let query = {...filter};
        this.props.fetchMedias(this.aqp.set(query));
    }

    // handleFilter(name, value) {
    //     let filter = {...this.state.filter, [name]: value, page: 1};
    //     this.setState({filter});
    //     this.getMedias(filter);
    // }

    handleFilter(name, value) {
        if(name === "Homme" || name === "Femme" || name === "Couple" || name === "Travesti"){
            let gender = [...this.state.filter.gender];

            let indexList = config.genderList.indexOf(name);
            let index = gender.indexOf(indexList);
            if(index >=0){
                gender.splice(index, 1);
            }
            else{
                gender.push(indexList);
            }

            let filter = {...this.state.filter,gender, page: 1};
            this.setState({filter});
            this.getMedias(filter);
        }
        else if(name === "sort"){
            let filter = {...this.state.filter, [name]: value, page: 1};
            if(value === 0){
                filter = {...filter, period: 2};
            }
            this.setState({filter});
            this.getMedias(filter);
        }
        else {
            let filter = {...this.state.filter, [name]: value, page: 1};
            this.setState({filter});
            this.getMedias(filter);
        }
    }

    isToogleGender(name){
        let gender = [...this.state.filter.gender];
        let indexList = config.genderList.indexOf(name);
        let index = gender.indexOf(indexList);
        return index >= 0 ? true : false;
    }

    handlePeriod(period, currentYear, currentMonth) {
        let filter = {...this.state.filter, page: 1};
        if (period === 3) {
            currentYear = filter.currentYear !== "" ? currentYear : new Date().getFullYear();
            currentMonth = filter.currentMonth !== "" ? currentMonth : new Date().getMonth() + 1;
            filter = {...filter, period, currentYear, currentMonth};

        } else {
            filter = {...filter, period, currentYear: "", currentMonth: ""};
        }
        this.setState({filter});
        this.getMedias(filter);
    }

    handleChangePage(page) {
        let filter = {...this.state.filter, page};
        this.setState({filter});
        this.getMedias(filter);
        window.scrollTo(0, 0);
    }
/*
    handleChangeVideoSelection(index) {
        if(index !== this.state.currentVideoSelection){
            let filter = {...this.state.filter, page: 1, videoSelectionVoissa: index === 0};
            this.setState({currentVideoSelection: index, filter});
            this.getMedias(filter);
        }
    }*/

    handleVideoCategorie(tag) {
        let url = createLink("tagVideo", {tag : tag, showAll :true});
        history.push(url);
        // if (id === this.state.filter.tags) {
        //         //     id = "";
        //         // }
        //         // let filter = {...this.state.filter, tags: id, page: 1};
        //         //
        //         // this.setState({filter});
        //         // this.getMedias(filter);

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.props.videoCategoriesInitialized !== nextProps.videoCategoriesInitialized){
            return true;
        }
        if(this.state === nextState){
            return true;
        }
        if ( this.state.leftArrowVisible !== nextState.leftArrowVisible || this.state.rightArrowVisible !== nextState.rightArrowVisible ) {
            return true;
        }
        if(this.props.match.params !== nextProps.match.params){
            return true;
        }
        if(this.props.mediasLoading !== nextProps.mediasLoading){
            return true;
        }
        if(this.state.toggleUpload !== nextState.toggleUpload){
            return true;
        }
        if(this.props.lastUpdate !== nextProps.lastUpdate){
            return true;
        }
        return nextProps.mediasInitialized !== this.props.mediasInitialized;
    }

    facetteTagScroll(direction) {
        let wrapper = document.querySelector('.tags-wrapper');
        let tags = wrapper.querySelector('.tags');
        let width = wrapper.offsetWidth;
        let fullwidth = tags.offsetWidth;
        let minLeft = width - fullwidth;
        let leftScroll = parseFloat(tags.leftScroll);
        if ( isNaN(leftScroll) ) {
            leftScroll = 0;
        }

        let tagArray = tags.querySelectorAll('.tag');
        let firstNotVisibleRightTag = null;
        tagArray.forEach(function(tag) {
            if ( tag.offsetLeft + tag.offsetWidth + leftScroll <= width ) {
                firstNotVisibleRightTag = tag.nextElementSibling;
            }
        });

        let res = { hideLeft: false, hideRight: false };

        if ( isNaN(leftScroll) ) {
            leftScroll = 0;
        }

        if ( direction === 1 ) {
            leftScroll += width;
        }
        else if ( direction === -1 ) {
            if ( firstNotVisibleRightTag ) {
                leftScroll -= firstNotVisibleRightTag.offsetLeft + leftScroll;
                if ( leftScroll <= minLeft ) {
                    leftScroll = minLeft;
                    res.hideRight = true;
                }
            }
            else {
                leftScroll = minLeft;
                res.hideRight = true;
            }
        }

        if ( leftScroll > 0 ) {
            leftScroll = 0;
            res.hideLeft = true;
        }
        tags.leftScroll = leftScroll;
        tags.style.left = leftScroll + 'px';
        return res;
    }
    facetteTagShowHideArrows(res) {
        this.setState({leftArrowVisible: !res.hideLeft});            
        this.setState({rightArrowVisible: !res.hideRight});            
    }
    facetteTagScrollLeft() {
        let res = this.facetteTagScroll(1);
        this.facetteTagShowHideArrows(res);
        return false;
    }
    facetteTagScrollRight() {
        let res = this.facetteTagScroll(-1);
        this.facetteTagShowHideArrows(res);
        return false;
    }

    render() {
        let totalPage = this.props.medias ? Math.ceil(this.props.mediasTotal / this.state.filter.limit) : 0;
        let url = this.aqp.queryUrl(this.state.filter, mapping);
        let currentPage = parseInt(this.state.filter.page);

        return !this.props.mediasInitialized ? (
            <div id="gallery">
                <div className="container">
                    <div className="card big">
                        <PageLoader/>
                    </div>
                </div>
            </div>
        ) : (
            <div id="gallery">
                <Helmet>
                    <title>VIDÉO PORNO DE SEXE AMATEUR sur Voissa {currentPage >1 ? `( page ${currentPage} )` : ""}</title>
                    <meta name="description" content={"Les ✔ meilleures Vidéos sexe Amateur ✔ sur Voissa. Les vidéos porno sont envoyées tous les jours par des amateurs et amatrices ★ 100% français. ★"} />
                    <meta name="keywords" content={"amateur et sexe, video sexe, sexe et amateur, sexe video, sexe amateur fr"} />
                    {currentPage === 2 && (<link rel="prev" href={canonical(url.link, url.search, "videos") }/>)}
                    {currentPage >= 3 && (<link rel="prev" href={canonical(`${url.link}/${(currentPage - 1)}`, url.search, "videos")} />)}
                    <link rel="canonical" href={currentPage >1 ? canonical(`${url.link}/${currentPage}`, url.search, "videos") : canonical(url.link, url.search, "videos")} />
                    {currentPage < totalPage && (<link rel="next" href={canonical(`${url.link}/${(currentPage +1)}`, url.search, "videos")} />)}
                </Helmet>
                <Can action={"qualification"} subject="TagModeration">
                    <TagModerationQualificationWarning />
                </Can>
                <div className="container">
                    <Advertising sizeMobile={"300x100"} className={"center"} />
                    <div className="card big">
                        <div className="card-controls">
                            <div className="main-controls-row">
                                <div>
                                    <Title heading={"heading-1"} display={"display-2"}>Vidéo sexe amateur</Title>
                                    {/*<div className={"head-title  display-2"}>
                                        <Fragment>
                                            <span className={this.state.currentVideoSelection === 0 ? 'active' : ''}
                                                  onClick={() => this.handleChangeVideoSelection(0)}>Sélection Voissa</span>
                                            <span className={this.state.currentVideoSelection === 1 ? 'active' : ''}
                                                  onClick={() => this.handleChangeVideoSelection(1)}>Toutes les vidéos</span>
                                        </Fragment>
                                    </div>*/}
                                </div>
                                <div className="filters">
                                    <Dropdown align="right" activableComponent={(
                                        <Button size={"small"}
                                                icon={"sliders"}
                                                content={"Filtres"}/>
                                    )}>

                                        <ul className="dropdown-menu">
                                            {/*{this.props.currentUserInitialized &&*/}
                                            {/*<li className="menu-item">Mes ami(e)s<Toggle*/}
                                            {/*    isToggled={this.state.filter.isFriends}*/}
                                            {/*    onToggle={() => this.handleFilter("isFriends", !this.state.filter.isFriends)}/>*/}
                                            {/*</li>*/}
                                            {/*}*/}
                                            <li className="menu-item">Les Voissa Créateurs<Toggle
                                                isToggled={this.state.filter.isCreator}
                                                onToggle={() => this.handleFilter("isCreator", !this.state.filter.isCreator)}/>
                                            </li>
                                            <li className="menu-item">Les hommes<Toggle
                                                isToggled={this.isToogleGender("Homme")}
                                                onToggle={() => this.handleFilter("Homme", !this.state.filter.isMan)}/>
                                            </li>
                                            <li className="menu-item">Les femmes<Toggle
                                                isToggled={this.isToogleGender("Femme")}
                                                onToggle={() => this.handleFilter("Femme", !this.state.filter.isWoman)}/>
                                            </li>
                                            <li className="menu-item">Les couples<Toggle
                                                isToggled={this.isToogleGender("Couple")}
                                                onToggle={() => this.handleFilter("Couple", !this.state.filter.isCouple)}/>
                                            </li>
                                            <li className="menu-item">Les Trans / Trav<Toggle
                                                isToggled={this.isToogleGender("Travesti")}
                                                onToggle={() => this.handleFilter("Travesti", !this.state.filter.isTrans)}/>
                                            </li>
                                        </ul>
                                    </Dropdown>
                                    <Can action={"upload"} subject="Media">
                                        <Button className={"access-upload-btn"}
                                                size={"small"}
                                                btnStyle={"primary-reverse"}
                                                onClick={() => this.setState({toggleUpload: true})}
                                                content={'Envoyer ma vidéo'}/>
                                    </Can>
                                    <Modal toggle={this.state.toggleUpload}
                                           handleClose={() => this.setState({toggleUpload: false})}>
                                        <Upload handleClose={() => this.setState({toggleUpload: false})}/>
                                    </Modal>

                                </div>
                            </div>

                            <div className={"sub-controls-row"}>
                                <h3 className={"sub-controls-row-link sort-row-link"}>
                                    {this.sort.map(item=><span key={item.id} className={this.state.filter.sort === item.id ? 'active' : ''} onClick={() => this.handleFilter("sort",item.id)}>{item.title}</span>)}
                                </h3>
                            </div>
                            {this.state.filter.sort !== 0 ? (
                                <SubControls
                                    handlePeriod={this.handlePeriod}
                                     period={this.state.filter.period}
                                     currentYear={this.state.filter.currentYear}
                                     currentMonth={this.state.filter.currentMonth}
                                     isVideo={true}
                                />
                            ) : null}

                        </div>

                        {this.props.videoCategories && this.props.videoCategories.length >= 1 && (
                            <div className={`video-categories-container ${this.state.toggleCategories ? 'active' : ''}`}>
                                <div className="tags-wrapper">
                                    <div className="tags">
                                        {Array.isArray(this.props.videoCategories) && this.props.videoCategories.map((item) => (
                                            <Link key={item._id} to={createLink('facette', {slug : item.uri})} className={"tag"}>
                                                <Button
                                                size={"small"}
                                                btnStyle={"primary-reverse"}
                                                content={item.title}/>
                                            </Link>
                                            ))
                                        }
                                    </div>
                                </div>
                                { this.state.leftArrowVisible ? <div className="arrow arrow-left" onClick={() => this.facetteTagScrollLeft()}></div> : null }
                                { this.state.rightArrowVisible ? <div className="arrow arrow-right" onClick={() => this.facetteTagScrollRight()}></div> : null }
                            </div>
                        )}

                        <div className={"column"}>
                            {this.props.mediasLoading && (
                                <LoadingBar />
                            )}
                            {totalPage > 1 &&
                            <Pagination
                                className={"mt-0 mb-16"}
                                currentPage={this.state.filter.page}
                                pagesCount={totalPage}
                                {...this.aqp.queryUrl(this.state.filter, mapping)}
                                handleChangePage={this.handleChangePage}
                            />
                            }
                            <div className="thumbs-grid">
                                {Array.isArray(this.props.medias) && this.props.medias.map((media) => (
                                    <Thumb key={media._id} {...media} cropTitle={45} />
                                ))}
                                {this.props.mediasTotal === 0 && (
                                    <div className={"no-content"}>Il n'y a aucune vidéo</div>
                                )}
                            </div>
                            {totalPage > 1 &&
                            <Pagination
                                currentPage={this.state.filter.page}
                                pagesCount={totalPage}
                                {...this.aqp.queryUrl(this.state.filter, mapping)}
                                handleChangePage={this.handleChangePage}
                            />
                            }
                        </div>
                        {this.state.filter.page === 1 ? (
                            <div className={"footer-medias"}>
                                <p>Si vous aimez les vidéos amateur et que vous aimez découvrir l'univers de ceux qui les publient, peut-être que vous ne quitterez plus jamais Voissa.</p>

                                <p>Depuis 20 ans, les membres de notre communauté ont publié des dizaines de milliers de vidéos de leur intimité. En couple, en solo ou à plusieurs, dans leur maison ou chez les autres. Des vidéos sensuelles, des vidéos plus sexuelles voire parfois même des <strong>vidéos porno</strong> (non ce n'est pas un gros mot), chacun profite de Voissa au gré de ses envies et reste libre de se montrer comme il a envie d'être vu.</p>

                                <p>Voissa est devenu la plus grande source de <strong>vidéos amateur</strong> car nos membres s'y sentent en sécurité, ils aiment l'esprit de respect et de partage qui y règne, ils apprécient de savoir que leur exhibition s'arrête aux portes de notre communauté, qu'ils ne pourront pas être vus par n'importe qui.</p>

                                <p>A nous lire vous pensez peut-être que c'est payant, pourtant non, profiter des vidéos sur Voissa est 100% gratuit, sur ordinateur, mobile ou tablette, vous profitez du meilleur sans rien débourser.</p>

                                <p><span>Vidéo porno ? Non sur Voissa nous valorisons le contenu amateur de qualité !</span>
                                </p>

                                <p>Nos membres se mettent en scène car ils aiment qu'on regarde leur intimité, ils font
                                    attention à produire du contenu de grande qualité (notamment les Voissa créateurs) et
                                    beaucoup d'entre eux adorent qu'on les commente donc si vous avez une minute il est
                                    primordial de leur dire à quel point vous aimez ce qu'ils publient (un commentaire, un
                                    like, c'est vous qui décidez).</p>

                                <p>Nous avons conscience que tout le monde ne souhaite pas (en tout cas pas tout de suite)
                                    voir des <strong>vidéos de sexe</strong>. Nous avons donc mis en place un filtre pour
                                    privilégier le contenu de qualité (longue durée). Vous disposez aussi d'un menu pour
                                    vous aider à choisir entre différents thème. Les titres devraient vous guider, libre à
                                    vous de passer la porte pour voir une vidéo porno ou une vidéo plus soft :</p>

                                <p>Tout en douceur, vidéos de sexe charnel (Bestial), les trios (plans à trois qui n'en a
                                    jamais rêvé), à plusieurs (plus de trois personnes), masqués pour les fétichistes, jeux
                                    sensuels pour les coquins, en plein air, en public, à la maison (amateur), entre elles
                                    pour ceux qui aiment le sexe lesbien, de elle à lui (souvent une fellation), de lui à
                                    elle (cunnilingus), les caresses féminines (madame se touche) et une dernière catégorie
                                    ou sont présentes uniquement les vidéos soft.</p>
                            </div>
                        ) : null}

                    </div>
                </div>
                <MobileLiveTool/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        medias: state.medias.data,
        lastUpdate : state.medias.lastUpdate || 0,
        mediasLoading: state.medias.loading,
        mediasInitialized: state.medias.initialized,
        mediasTotal: state.medias.total,
        currentUserInitialized: state.currentUser.initialized,
        videoCategories: state.videoCategories.data,
        videoCategoriesInitialized: state.videoCategories.initialized,
        videoCategoriesTotal: state.videoCategories.total,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchMedias,
    resetMedias,
    fetchVideoCategories
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Video);
